import WTypography from "../wtypography/WTypography";
import WButton from "../wbutton/WButton";
import { Dispatch } from "react";
import { UsersPermissionsUserQuery } from "@/generated";
import { ApolloError } from "@apollo/client";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

interface IProfileInfoProps {
  profile:
    | NonNullable<
        NonNullable<UsersPermissionsUserQuery["usersPermissionsUser"]>["data"]
      >["attributes"]
    | null
    | undefined;
  isMe: boolean;
  myId: number | string;
  isLoading: boolean;
  isError: ApolloError;
  isPrivate: boolean;
  onEdit: Dispatch<void>;
  userId?: number | string;
}

export const WProfileInfo = ({
  profile,
  isMe = false,
  isPrivate = false,
  onEdit,
}: IProfileInfoProps) => {
  const { t } = useTranslation("profile");

  return (
    <>
      <div
        className={clsx([
          "relative flex flex-col gap-20 max-w-full lg:flex-row",
        ])}
      >
        <div className="flex-col flex-wrap lg:flex">
          {isMe && <div>{t("welcome-back")}</div>}
          <div className="text-3xl font-bold">{`${profile?.firstName} ${profile?.lastName}`}</div>
          {!isPrivate ? (
            <>
              <div className="mt-5">
                {`${profile?.firstName} ${profile?.lastName}`}
              </div>
              <div className="flex items-center gap-3 mt-5 lg:w-80" />
            </>
          ) : (
            <div className="mt-5">
              <WTypography text={t("account-is-private").toString()} />
            </div>
          )}

          <div className="flex gap-5 mt-5">
            {isMe ? (
              <div className="flex flex-col gap-2">
                <WButton
                  text={t("edit-profile").toUpperCase()}
                  type="secondary-small"
                  className="w-auto"
                  icon="edit"
                  onClick={onEdit}
                />
              </div>
            ) : (
              <div className="flex flex-wrap justify-center w-full gap-5">
                <WButton
                  text={t("report").toUpperCase()}
                  type="decline"
                  className="w-full lg:w-auto"
                  onClick={() => console.log("Raport user")}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default WProfileInfo;
